// Customer 360 · "Old quotes" — this customer's archived + deleted quotes, restorable.
import { useCallback, useEffect, useState } from "react";
import { ChevronDown, History } from "lucide-react";
import api from "../../lib/api";
import OldQuoteRow from "../quotes/OldQuoteRow";

export default function OldQuotesCard({ personId, onRestored }) {
  const [items, setItems] = useState(null);
  const [open, setOpen] = useState(false);
  const load = useCallback(() => api.get(`/crm/persons/${personId}/old-quotes`).then(({ data }) => setItems(data.items)).catch(() => setItems([])), [personId]);
  useEffect(() => { load(); }, [load]);
  if (!items) return null;
  return (
    <div className="rounded-xl border border-white/10 bg-white/[0.02]" data-testid="old-quotes-card">
      <button type="button" onClick={() => setOpen((v) => !v)} className="w-full flex items-center gap-2 p-4" data-testid="old-quotes-toggle">
        <History className="w-4 h-4 text-slate-300" /><span className="text-sm font-semibold text-white">Old quotes (archived &amp; deleted)</span>
        <span className="text-[11px] font-mono text-slate-400" data-testid="old-quotes-count">{items.length}</span>
        <ChevronDown className={`w-4 h-4 ml-auto text-slate-400 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (items.length === 0 ? <div className="px-4 pb-4 text-[12px] text-slate-500">No archived or deleted quotes for this customer.</div>
        : <div className="border-t border-white/[0.06]">{items.map((r) => <OldQuoteRow key={`${r.where}-${r._id}`} r={r} showCustomer={false} onRestored={() => { load(); onRestored?.(); }} />)}</div>)}
    </div>
  );
}
